import React, { useState } from "react";
import { Dialog } from "@headlessui/react";
import { sendTestChallenge } from "../lib/challengeLib";
import { useSnackbar } from "../contexts/SnackbarContext";

interface TestChallengeModalProps {
  isOpen: boolean;
  onClose: () => void;
  inboxId: string;
}

const TestChallengeModal: React.FC<TestChallengeModalProps> = ({
  isOpen,
  onClose,
  inboxId,
}) => {
  const [isSending, setIsSending] = useState(false);
  const { showSnackbar } = useSnackbar();

  const handleSendTest = async () => {
    try {
      setIsSending(true);
      await sendTestChallenge(inboxId);
      showSnackbar("Test challenge sent successfully", "success");
      onClose();
    } catch (error) {
      console.error("Failed to send test challenge:", error);
      showSnackbar("Failed to send test challenge", "error");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-lg rounded bg-white dark:bg-gray-800 p-6">
          <Dialog.Title className="text-lg font-medium mb-4 dark:text-white">
            Send Test Challenge
          </Dialog.Title>
          <div className="prose dark:prose-invert mb-6">
            <p className="text-gray-600 dark:text-gray-300">
              This will send a test email to your inbox which Cobutler will
              always challenge. You can use this to:
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300">
              <li>Preview your challenge email appearance</li>
              <li>Test the donation or bypass flow</li>
              <li>Verify your inbox settings are working as expected</li>
            </ul>
            <p className="text-gray-600 dark:text-gray-300 mt-4">
              The test email will be sent to your inbox immediately.
            </p>
          </div>
          <div className="flex justify-end space-x-4">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
            >
              Cancel
            </button>
            <button
              onClick={handleSendTest}
              disabled={isSending}
              className={`px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed ${
                isSending ? "cursor-wait" : ""
              }`}
            >
              {isSending ? "Sending..." : "Send Test"}
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default TestChallengeModal;
